import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, renderList as _renderList, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_line.png'
import _imports_1 from '@/assets/image/footer/kakao_footer.png'
import _imports_2 from '@/assets/image/vipImg/card_user_head.png'
import _imports_3 from '@/assets/image/vipImg/vip-special-qrcode.png'
import _imports_4 from '@/assets/image/vipImg/vip_line2_left.png'
import _imports_5 from '@/assets/image/vipImg/vip_line2_right.png'
import _imports_6 from '@/assets/image/vipImg/vip_background_crown.png'
import _imports_7 from '@/assets/image/vipImg/vip_background_the_ckb.png'
import _imports_8 from '@/assets/image/icon/member/icon_email@2x.png'
import _imports_9 from '@/assets/image/icon/member/icon_phone@2x.png'
import _imports_10 from '@/assets/image/vipImg/icon_charge.png'
import _imports_11 from '@/assets/image/vipImg/vip_icon_remind.png'


const _withScopeId = n => (_pushScopeId("data-v-ff4a11f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = {
  key: 0,
  class: "special-info"
}
const _hoisted_3 = { class: "user-info-top special-bg" }
const _hoisted_4 = { class: "user-info-main" }
const _hoisted_5 = { class: "user-info-content wrapper" }
const _hoisted_6 = { class: "user-info-left" }
const _hoisted_7 = {
  key: 0,
  class: "user-info-title"
}
const _hoisted_8 = {
  key: 1,
  class: "user-info-title"
}
const _hoisted_9 = { class: "user-info-text" }
const _hoisted_10 = { class: "user-contact" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 1,
  href: "https://pf.kakao.com/_uzWxoxj",
  target: "_blank",
  class: "user-online"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "text" }
const _hoisted_17 = {
  class: "user-online flex-fdc",
  style: {"left":"290px"}
}
const _hoisted_18 = { class: "plan flex-cen-ter" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-bianzu5" }, null, -1))
const _hoisted_20 = { class: "text" }
const _hoisted_21 = { class: "plan flex-cen-ter" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-a-24gf-telephone" }, null, -1))
const _hoisted_23 = { class: "text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-huiyuankaitongjilu" }, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "user-info-card"
}
const _hoisted_26 = { class: "user-name" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_28 = { class: "user-status" }
const _hoisted_29 = {
  key: 1,
  class: "user-status-tip"
}
const _hoisted_30 = { class: "time flex-ter" }
const _hoisted_31 = {
  key: 0,
  class: "yuchong-time"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 2,
  class: "user-info-card flex-col flex-bwn"
}
const _hoisted_34 = { class: "user-status" }
const _hoisted_35 = { class: "user-status-tip" }
const _hoisted_36 = {
  key: 0,
  class: "wrapper user-recomon"
}
const _hoisted_37 = { class: "wrapper user-equity" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 0,
  class: "signUpNum"
}
const _hoisted_40 = {
  key: 1,
  class: "membership-btn"
}
const _hoisted_41 = { class: "price" }
const _hoisted_42 = { class: "line-price" }
const _hoisted_43 = { class: "line-price-value" }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "vip-special-code" }
const _hoisted_46 = { class: "wrapper" }
const _hoisted_47 = { class: "vip-special-left" }
const _hoisted_48 = { class: "vip-special-tag" }
const _hoisted_49 = { class: "vip-special-tip" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vip-special-right",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_51 = {
  key: 1,
  class: "vip-template-box"
}
const _hoisted_52 = { class: "vip-template-header" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_54 = { class: "title" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_56 = { class: "vip-template" }
const _hoisted_57 = { class: "toDetail flex-cen-ter cursor-pt" }
const _hoisted_58 = ["src"]
const _hoisted_59 = ["href"]
const _hoisted_60 = ["src"]
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "user-info-top" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "",
  class: "vip-crown"
}, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "",
  class: "vip-the-ckb"
}, null, -1))
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = { class: "user-info-content abs" }
const _hoisted_67 = { class: "user-info-left" }
const _hoisted_68 = { class: "user-info-title" }
const _hoisted_69 = { class: "user-info-text" }
const _hoisted_70 = ["href"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_72 = { class: "text" }
const _hoisted_73 = {
  key: 1,
  href: "https://pf.kakao.com/_uzWxoxj",
  target: "_blank",
  class: "abs user-online"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_75 = { class: "text" }
const _hoisted_76 = { class: "plan flex-cen-ter" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_8,
  alt: ""
}, null, -1))
const _hoisted_78 = { class: "text" }
const _hoisted_79 = { class: "plan flex-cen-ter" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_9,
  alt: ""
}, null, -1))
const _hoisted_81 = { class: "text" }
const _hoisted_82 = { class: "user-info-card" }
const _hoisted_83 = { class: "user-name" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_85 = {
  key: 1,
  class: "user-status-tip"
}
const _hoisted_86 = { class: "time flex-ter" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1))
const _hoisted_89 = { class: "vip-template-container" }
const _hoisted_90 = {
  key: 0,
  class: "vip-template"
}
const _hoisted_91 = { class: "toDetail flex-cen-ter cursor-pt" }
const _hoisted_92 = ["src"]
const _hoisted_93 = ["href"]
const _hoisted_94 = ["src"]
const _hoisted_95 = {
  key: 1,
  class: "special-bg"
}
const _hoisted_96 = {
  key: 0,
  class: "wrapper user-recomon"
}
const _hoisted_97 = { class: "wrapper user-equity" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = {
  key: 0,
  class: "signUpNum"
}
const _hoisted_100 = {
  key: 1,
  class: "membership-btn"
}
const _hoisted_101 = { class: "price" }
const _hoisted_102 = { class: "line-price" }
const _hoisted_103 = { class: "line-price-value" }
const _hoisted_104 = { key: 2 }
const _hoisted_105 = { class: "vip-special-code" }
const _hoisted_106 = { class: "wrapper" }
const _hoisted_107 = { class: "vip-special-left" }
const _hoisted_108 = { class: "vip-special-tag" }
const _hoisted_109 = { class: "vip-special-tip" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vip-special-right",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_111 = {
  key: 1,
  class: "vip-template-box"
}
const _hoisted_112 = { class: "vip-template-header" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_114 = { class: "title" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_116 = { class: "vip-template" }
const _hoisted_117 = { class: "toDetail flex-cen-ter cursor-pt" }
const _hoisted_118 = ["src"]
const _hoisted_119 = ["href"]
const _hoisted_120 = ["src"]
const _hoisted_121 = { class: "waring_header" }
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1))
const _hoisted_123 = { class: "waring_tips" }
const _hoisted_124 = { class: "footer" }

import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { ref, computed, onMounted, nextTick } from 'vue'
import { ArrowRight } from '@element-plus/icons-vue'
import { getAutomaticToggleStaus, getVipCombo, automaticToggle, getPrecharegeOrderApi, isFirstPayVipApi, getVipSpecial, promotionDetail, superCustomerId } from '@/apis/usercenter'
import { useRequest } from '@/util/useLoading'
// 底部1-4级会员card
import VipCard from './components/VipCard.vue'
import PayConfirm from './components/PayConfirm.vue'
import PayContent from './components/PayContent.vue'
import SetShop from './components/SetShop.vue'
import ADialog from './ADialog.vue'
import PaySuccessVue from './components/PaySuccess.vue'
import AutoPayDisabled from './components/AutoPayDisabled.vue'
import PayError from './components/payError.vue'
import VipHistory from './components/VipHistory.vue'
import MemberLimitedTime from '@/components/bussiness/MemberCenter/MemberLimitedTime.vue'
import Recommon from './components/recommon.vue'
import VipEquity from './components/VipEquity.vue'
import PaypalTip from './components/PaypalTip.vue'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { useRtfix, isJA, isKO, isD2C, useSite, isEN } from '@/store'
import { formatMoney } from '@/plugins/utils'
import { lineUrl, serverEmail, serverPhone } from '@/common/const'

export default /*#__PURE__*/_defineComponent({
  props: {
  isInvitatePage: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props

// 料金详细url链接
const feeUrl = isJA() ? 'https://www.theckb.com/price/plan/' : isKO() ? 'https://korea.theckb.com/price#2' : 'https://www.theckbofficial.com/price'
const router = useRouter()
const store = useStore()
// 是否登录
const isLogin = ref(!!store.getters.token)
const isSub = store.getters.isSub
const userInfo = computed(() => {
  return store.getters.user
})
const isAuto = ref()
const isPayType = ref()
const confirmVisible = ref(false)
const payVisible = ref(false)
const setShopVisible = ref(false)
const aDialogVisible = ref(false)
const paySuccessVisible = ref(false)
const autoPayDisabledVisible = ref(false)
const payErrorVisible = ref(false)
const isOutTimeVip = ref(false)
const vipHistoryVisible = ref(false)
const paypalTipVisible = ref(false)
const sepecialConfig = ref([])
// B2B显示
const sepecialRightTb = ref([])
// D2C显示
const sepecialRightTc = ref([])
// 开通会员弹窗
const openVipVisible = ref(false)

/** 特殊会员新人活动标识 */
const newSpecialMemberFlag = ref(false)

/** 特殊会员新人活动信息 */
const newSpecialMember = ref<any>({})

/** 是否展示特殊会员逻辑 */
const isSpecial = ref(false)
const specailInfo = ref()
const invitationCode = ref('')
// 是不是推广页面

const membership = store.getters.membership

onMounted(() => {
  if (userInfo.value?.membership.templateLevel === 0) {
    isFirstPayVipApi({}).then((res) => {
      isOutTimeVip.value = res.data
    })
  }
  // 特殊会员配置（有token按实际返回，没有则返回默认配置）
  getVipSpecial().then((res: any) => {
    sepecialConfig.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateConfigReqVOList || []
    sepecialRightTb.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateRightReqVOListToB || []
    sepecialRightTc.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateRightReqVOListToC || []

    isSpecial.value = res.data?.isShow
    specailInfo.value = res.data
    const flag = res.data.priceItemList.some((v: any) => v.trialFlag)
    newSpecialMemberFlag.value = flag
    if (flag) {
      const newMember = res.data.priceItemList.filter((v: any) => v.trialFlag)[0]
      newSpecialMember.value = newMember
    }
  })
  // 推广者联盟的邀请码

  // 推广者身份判断
  if (membership?.superCustomerId) {
    superCustomerId({ superCustomerId: membership.superCustomerId }).then(res => {
      // 只有特殊会员才有推广码
      if (res.data?.ruleType === 'PRO') {
        promotionDetail({}).then(res => {
          invitationCode.value = res.data?.invitationCode
        })
      }
    })
  }
})

const getAutoStatus = () => {
  getAutomaticToggleStaus({
    superCustomerId: membership?.superCustomerId
  }).then(res => {
    isAuto.value = res?.data?.automaticRenewalStatus
    isPayType.value = res?.data?.automaticRenewalStytle
  })
}
getAutoStatus()
const comboList: any = ref([])
const [loading, api] = useRequest(getVipCombo)
api().then((res) => {
  comboList.value = res?.data || []
})

const comboListShowList = computed(() => {
  console.log(comboList.value, 'comboList')
  return comboList.value.filter((i: { isShow: any }) => i.isShow)
})

// 充值的会员信息
const vipInfo = ref()
const payConfirmRef = ref()
const openModal = (item: any) => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改会员等级'))
    return
  }
  vipInfo.value = item
  if (userInfo.value?.membership.templateLevel > 0) {
    confirmVisible.value = true
    payConfirmRef.value.open(item)
  } else {
    // 非会员直接支付
    payContentRef.value.open({
      vipInfo: item,
      checkValue: 1
    })
    payVisible.value = true
  }
}

// 关闭自动续费
const closeAutoPay = () => {
  automaticToggle({
    automaticRenewalStatus: 2,
    automaticRenewalStytle: isPayType.value
  }).then((res: any) => {
    if (res.success) {
      aDialogVisible.value = false
      ElMessage.success(t('关闭成功'))
      // reload()
      getAutoStatus()
      console.log('isPayType.value', isPayType.value)
      // 如果是paypal自动续费续费取消弹窗
      if (isPayType.value === 2) {
        // paypalTipVisible.value = true
      }
    }
  })
}

const openADialogVisible = () => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改'))
    return
  }
  aDialogVisible.value = true
}
// 开启自动续费
const openAutoVisible = () => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改'))
    return
  }
  if (beforehandVipInfo.value.oldExpiresDate) {
    // 如果是预充会员提示不允许自动续费
    autoPayDisabledVisible.value = true
    return
  }
  automaticToggle({
    automaticRenewalStatus: 1,
    automaticRenewalStytle: 1 // 开启续费永远是余额续费
  }).then((res: any) => {
    if (res.success) {
      aDialogVisible.value = true
    }
  })
}
const changeSwitch = () => {
  if (isAuto.value === 1) {
    openADialogVisible()
  } else {
    openAutoVisible()
  }
}
const reload = () => location.reload()

const beforehandVipInfo = ref()
// 是否预充会员
getPrecharegeOrderApi({
  superCustomerIds: membership?.superCustomerId
}).then((res: any) => {
  console.log(res)
  beforehandVipInfo.value = res?.data[0] || {}
})
const payContentRef = ref()
const submitPay = (info: any) => {
  payContentRef.value.open(info)
  confirmVisible.value = false
  payVisible.value = true
}
const paySuccessVue = ref()
const paySuccess = (info: any) => {
  console.log('inde', info)
  paySuccessVue.value.open(info)
  payVisible.value = false
  paySuccessVisible.value = true
}

// 续费
const renew = () => {
  let obj = {}
  comboList.value.forEach((item: any) => {
    if (item.membershipTemplateId === membership?.membershipTemplateId) {
      obj = item
    }
  })
  // 当用户为特殊用户时。需要单独取特殊会员续费列表
  if (userInfo.value.membership.specialType !== 0) {
    obj = specailInfo.value
  }
  openModal(obj)
}

const closePaySuccess = () => {
  isFirstPayVipApi({}).then((res) => {
    if (res.data) {
      // 不是第一次充值
      reload()
    } else {
      setShopVisible.value = true
    }
  })
}

// 未开通会员的情况下开通会员(只有特殊推广的情况可进入)
const openVip = () => {
  if (isLogin.value) {
    if (props.isInvitatePage && !isSpecial.value) {
      openVipVisible.value = true
      return
    }
    if (isSpecial.value || props.isInvitatePage) {
      openModal(specailInfo.value)
    } else {
      openModal(comboList.value[0])
    }
  } else {
    const code = router.currentRoute.value.query.code
    const inviteUrl = location.origin + '/signup?channel=0&code=' + code
    window.open(inviteUrl, '_blank')
  }
}

const errorPay = () => {
  payVisible.value = false
  payErrorVisible.value = true
}

const toDetailImg = require('@/assets/image/vipImg/icon_funds_detail@2x.png')
const memberLeft = require('@/assets/image/icon/member/member-left.png')

const newMemberActivity = computed(() => store.state.status.newMemberActivity)

// 复制专属会员推广链接
const copySpecialLink = () => {
  const href = `${location.origin}/special/invite?channel=0&code=${invitationCode.value}`
  const aux = document.createElement('input')
  aux.setAttribute('value', href)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  ElMessage.success(t('复制成功'))
}

// 当会员没有开通资格时弹窗
const openWarinVip = () => {
  router.push(useRtfix('VipLevel'))
}


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", _unref(useSite)()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.isInvitatePage || _unref(userInfo)?.membership.templateLevel === 0 && isSpecial.value || _unref(userInfo)?.membership.templateLevel === 5 && isSpecial.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (isSpecial.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString('THE CKB PRO会員')))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB')), 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('会员计划')), 1)
                        ])),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('THE CKB会员，为您的买卖生活提供一切所需。')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _unref(lineUrl),
                            target: "_blank",
                            class: "user-online"
                          }, [
                            _hoisted_12,
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('LINE 查询')), 1)
                          ], 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      (_unref(isKO)())
                        ? (_openBlock(), _createElementBlock("a", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('LINE 查询')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(serverEmail)()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(serverPhone)()), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass('user-info-right user-info-right' + _unref(userInfo)?.membership.templateLevel)
                  }, [
                    (isLogin.value && !__props.isInvitatePage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "vip-history",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (vipHistoryVisible.value = true))
                        }, [
                          _hoisted_24,
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('会员开通记录')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (isLogin.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", null, _toDisplayString(_unref(userInfo)?.loginName ?? ''), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(userInfo)?.membership.templateLevel === 0 ? (isOutTimeVip.value ? _unref(t)('已失去会员') : _unref(t)('未入会')) :
                    _unref(userInfo)?.membership.membershipTemplateName), 1),
                          (_unref(userInfo)?.membership.templateLevel === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_unref(newMemberActivity) && _unref(newMemberActivity).endTime !== '2999-12-31 23:59:59')
                                  ? (_openBlock(), _createBlock(MemberLimitedTime, { key: 0 }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(t)('入会优享超多服务')), 1)),
                                _createElementVNode("div", {
                                  class: _normalizeClass(`user-btn mt_${_unref(newMemberActivity) ? '20' : '30'}`),
                                  onClick: openVip
                                }, _toDisplayString(_unref(t)('开通会员')), 3)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_30, [
                                  (_unref(userInfo)?.membership.trialFlag)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["trialTag flex-cen-ter", _unref(useSite)()])
                                      }, _toDisplayString(isSpecial.value ? _unref(t)('特惠体验中') :
                        _unref(t)('试用')), 3))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_unref(t)('有效期至')) + "：", 1),
                                  _createElementVNode("div", null, _toDisplayString(_unref(userInfo)?.membership.expiresDate), 1)
                                ]),
                                (beforehandVipInfo.value?.oldExpiresDate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')) + " - " + _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.expiresDate).format('YYYY-MM-DD')) + " " + _toDisplayString(_unref(t)('{member}に変更予定', { member: beforehandVipInfo.value?.membershipTemplateName})), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass([{ active: isAuto.value === 1 }, 'auto-pay', { textline: isAuto.value === 1 }]),
                                  style: _normalizeStyle(_unref(isEN)() ? 'width: 190px;' : '')
                                }, [
                                  (isAuto.value !== 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_unref(t)('自动续费2')), 1))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        onClick: changeSwitch
                                      }, _toDisplayString(_unref(t)('自动续费2')), 1)),
                                  (isAuto.value !== 1)
                                    ? (_openBlock(), _createBlock(_component_el_switch, {
                                        key: 2,
                                        "model-value": isAuto.value === 1,
                                        "inline-prompt": "",
                                        "active-text": "ON",
                                        "inactive-text": "OFF",
                                        onClick: changeSwitch
                                      }, null, 8, ["model-value"]))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 3,
                                        onClick: changeSwitch
                                      }, "：ON"))
                                ], 6),
                                _createElementVNode("div", {
                                  class: _normalizeClass('pay-btn pay-btn' + _unref(userInfo)?.membership.templateLevel),
                                  onClick: renew
                                }, _toDisplayString(_unref(t)('去续费')), 3)
                              ], 64))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('未登録')), 1),
                            _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('入会优享超多服务')), 1)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(`user-btn mt_${_unref(newMemberActivity) ? '20' : '30'}`),
                            onClick: openVip
                          }, _toDisplayString(_unref(t)('开通会员')), 3)
                        ]))
                  ], 2)
                ]),
                (sepecialConfig.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(Recommon, {
                        newSpecialMemberFlag: newSpecialMemberFlag.value,
                        newSpecialMember: newSpecialMember.value,
                        list: sepecialConfig.value
                      }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "list"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  (sepecialRightTb.value.length || sepecialRightTc.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createVNode(VipEquity, {
                          newSpecialMemberFlag: newSpecialMemberFlag.value,
                          newSpecialMember: newSpecialMember.value,
                          tblist: sepecialRightTb.value,
                          tclist: sepecialRightTc.value
                        }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "tblist", "tclist"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "membership",
                    onClick: openVip
                  }, [
                    (newSpecialMemberFlag.value && newSpecialMember.value.limitedQuantityStatus)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(t)('名额仅剩X名').replace('X', newSpecialMember.value.lastQuantity)), 1))
                      : _createCommentVNode("", true),
                    (newSpecialMemberFlag.value && newSpecialMember.value.trialDiscount === -1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('新人开通专属会员享')), 1),
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.trialPrice)), 1),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)('円/首月')), 1),
                          _createElementVNode("span", _hoisted_42, [
                            _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.discountActualPrice)), 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('円/月')), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(t)('立即开通专属会员')), 1))
                  ]),
                  (invitationCode.value && isSpecial.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "copyLink",
                        onClick: copySpecialLink
                      }, _toDisplayString(_unref(t)('复制专属会员推广链接')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(t)('专属会员专享服务')), 1),
                      _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(t)('如有任何疑问，请用LINE扫描右侧二维码联系我们，获取专属咨询服务。')), 1)
                    ]),
                    _hoisted_50
                  ])
                ]),
                (!!_unref(comboListShowList)?.length && !__props.isInvitatePage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(t)('您还可选择THE CKB普通会员')), 1),
                        _hoisted_55
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("img", {
                            src: _unref(toDetailImg),
                            alt: ""
                          }, null, 8, _hoisted_58),
                          _createElementVNode("a", {
                            href: _unref(feeUrl),
                            target: "_blank"
                          }, _toDisplayString(_unref(t)('料金詳細')), 9, _hoisted_59),
                          _createElementVNode("img", {
                            src: _unref(memberLeft),
                            alt: "",
                            style: {"width":"16px","height":"16px"},
                            class: "right"
                          }, null, 8, _hoisted_60)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comboListShowList), (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (index < 4)
                              ? (_openBlock(), _createBlock(VipCard, {
                                  onOpen: ($event: any) => (openModal(item)),
                                  key: index,
                                  vipInfo: item
                                }, null, 8, ["onOpen", "vipInfo"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", {
                class: _normalizeClass('user-info-bg user-info-bg' + _unref(userInfo)?.membership.templateLevel)
              }, _hoisted_65, 2),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB')), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('会员计划')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, _toDisplayString(_unref(t)('THE CKB会员，为您的买卖生活提供一切所需。')), 1),
                  (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _unref(lineUrl),
                        target: "_blank",
                        class: "abs user-online"
                      }, [
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(t)('LINE 查询')), 1)
                      ], 8, _hoisted_70))
                    : _createCommentVNode("", true),
                  (_unref(isKO)())
                    ? (_openBlock(), _createElementBlock("a", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(t)('LINE 查询')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "abs user-online flex-fdc",
                    style: _normalizeStyle({left: _unref(isEN)() ? '' : '290px'})
                  }, [
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(serverEmail)()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("span", _hoisted_81, _toDisplayString(_unref(serverPhone)()), 1)
                    ])
                  ], 4)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass('user-info-right user-info-right' + _unref(userInfo)?.membership.templateLevel + ' '+ _unref(useSite)())
                }, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _createElementVNode("span", null, _toDisplayString(_unref(userInfo)?.loginName ?? ''), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["user-status", _unref(useSite)()])
                    }, _toDisplayString(_unref(userInfo)?.membership.templateLevel === 0 ? (isOutTimeVip.value ? _unref(t)('已失去会员') : _unref(t)('未入会')) :
                  _unref(userInfo)?.membership.membershipTemplateName), 3),
                    (_unref(userInfo)?.membership.templateLevel === 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_unref(newMemberActivity) && _unref(newMemberActivity).endTime !== '2999-12-31 23:59:59')
                            ? (_openBlock(), _createBlock(MemberLimitedTime, { key: 0 }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_unref(t)('入会优享超多服务')), 1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(`user-btn mt_${_unref(newMemberActivity) ? '20' : '30'}`),
                            onClick: openVip
                          }, _toDisplayString(_unref(t)('开通会员')), 3)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_86, [
                            (_unref(userInfo)?.membership.trialFlag)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["trialTag flex-cen-ter", _unref(useSite)()])
                                }, _toDisplayString(isSpecial.value ? _unref(t)('特惠体验中') :
                      _unref(t)('试用')), 3))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('有效期至')) + "：", 1),
                            _createElementVNode("div", null, _toDisplayString(_unref(userInfo)?.membership.expiresDate), 1)
                          ]),
                          (beforehandVipInfo.value?.oldExpiresDate)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["yuchong-time", _unref(useSite)()])
                              }, _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')) + " - " + _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.expiresDate).format('YYYY-MM-DD')) + " " + _toDisplayString(_unref(t)('{member}に変更予定', { member: beforehandVipInfo.value?.membershipTemplateName})), 3))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass([{ active: isAuto.value === 1 }, 'auto-pay', { textline: isAuto.value === 1 }]),
                            style: _normalizeStyle(_unref(isEN)() ? 'width: 190px;' : '')
                          }, [
                            (isAuto.value !== 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(_unref(t)('自动续费2')), 1))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  onClick: changeSwitch
                                }, _toDisplayString(_unref(t)('自动续费2')), 1)),
                            (isAuto.value !== 1)
                              ? (_openBlock(), _createBlock(_component_el_switch, {
                                  key: 2,
                                  "model-value": isAuto.value === 1,
                                  "inline-prompt": "",
                                  "active-text": "ON",
                                  "inactive-text": "OFF",
                                  onClick: changeSwitch
                                }, null, 8, ["model-value"]))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  onClick: changeSwitch
                                }, "：ON"))
                          ], 6),
                          _createElementVNode("div", {
                            class: _normalizeClass('pay-btn pay-btn' + _unref(userInfo)?.membership.templateLevel),
                            onClick: renew
                          }, _toDisplayString(_unref(t)('去续费')), 3)
                        ], 64))
                  ])
                ], 2)
              ]),
              _createElementVNode("div", {
                class: "vip-history",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (vipHistoryVisible.value = true))
              }, [
                _hoisted_88,
                _createElementVNode("span", null, _toDisplayString(_unref(t)('会员开通记录')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_89, [
              (!!_unref(comboListShowList).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("img", {
                        src: _unref(toDetailImg),
                        alt: ""
                      }, null, 8, _hoisted_92),
                      _createElementVNode("a", {
                        href: _unref(feeUrl),
                        target: "_blank"
                      }, _toDisplayString(_unref(t)('料金詳細')), 9, _hoisted_93),
                      _createElementVNode("img", {
                        src: _unref(memberLeft),
                        alt: "",
                        style: {"width":"16px","height":"16px"},
                        class: "right"
                      }, null, 8, _hoisted_94)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comboListShowList), (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (index < 4)
                          ? (_openBlock(), _createBlock(VipCard, {
                              onOpen: ($event: any) => (openModal(item)),
                              key: index,
                              vipInfo: item
                            }, null, 8, ["onOpen", "vipInfo"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  ]))
                : _createCommentVNode("", true),
              (isSpecial.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                    (sepecialConfig.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _createVNode(Recommon, {
                            newSpecialMemberFlag: newSpecialMemberFlag.value,
                            newSpecialMember: newSpecialMember.value,
                            list: sepecialConfig.value
                          }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "list"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_97, [
                      (sepecialRightTb.value.length || sepecialRightTc.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                            _createVNode(VipEquity, {
                              newSpecialMemberFlag: newSpecialMemberFlag.value,
                              newSpecialMember: newSpecialMember.value,
                              tblist: sepecialRightTb.value,
                              tclist: sepecialRightTc.value
                            }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "tblist", "tclist"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: "membership",
                        onClick: openVip
                      }, [
                        (newSpecialMemberFlag.value && newSpecialMember.value.limitedQuantityStatus)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_unref(t)('名额仅剩X名').replace('X', newSpecialMember.value.lastQuantity)), 1))
                          : _createCommentVNode("", true),
                        (newSpecialMemberFlag.value && newSpecialMember.value.trialDiscount === -1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('新人开通专属会员享')), 1),
                              _createElementVNode("span", _hoisted_101, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.trialPrice)), 1),
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('円/首月')), 1),
                              _createElementVNode("span", _hoisted_102, [
                                _createElementVNode("span", _hoisted_103, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.discountActualPrice)), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('円/月')), 1)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_104, _toDisplayString(_unref(t)('立即开通专属会员')), 1))
                      ]),
                      (invitationCode.value && isSpecial.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "copyLink",
                            onClick: copySpecialLink
                          }, _toDisplayString(_unref(t)('复制专属会员推广链接')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, _toDisplayString(_unref(t)('专属会员专享服务')), 1),
                          _createElementVNode("div", _hoisted_109, _toDisplayString(_unref(t)('如有任何疑问，请用LINE扫描右侧二维码联系我们，获取专属咨询服务。')), 1)
                        ]),
                        _hoisted_110
                      ])
                    ]),
                    (!!_unref(comboListShowList)?.length && _unref(userInfo)?.membership.templateLevel === 5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                          _createElementVNode("div", _hoisted_112, [
                            _hoisted_113,
                            _createElementVNode("span", _hoisted_114, _toDisplayString(_unref(t)('您还可选择THE CKB普通会员')), 1),
                            _hoisted_115
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("img", {
                                src: _unref(toDetailImg),
                                alt: ""
                              }, null, 8, _hoisted_118),
                              _createElementVNode("a", {
                                href: _unref(feeUrl),
                                target: "_blank"
                              }, _toDisplayString(_unref(t)('料金詳細')), 9, _hoisted_119),
                              _createElementVNode("img", {
                                src: _unref(memberLeft),
                                alt: "",
                                style: {"width":"16px","height":"16px"},
                                class: "right"
                              }, null, 8, _hoisted_120)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comboListShowList), (item, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (index < 4)
                                  ? (_openBlock(), _createBlock(VipCard, {
                                      onOpen: ($event: any) => (openModal(item)),
                                      key: index,
                                      vipInfo: item
                                    }, null, 8, ["onOpen", "vipInfo"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(PayConfirm, {
        visible: confirmVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((confirmVisible).value = $event)),
        beforehandVipInfo: beforehandVipInfo.value,
        ref: (_value, _refs) => {
          _refs['payConfirmRef'] = _value
          payConfirmRef.value = _value
        },
        onSubmit: submitPay
      }, null, 8, ["visible", "beforehandVipInfo"]),
      _createVNode(PayContent, {
        visible: payVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((payVisible).value = $event)),
        ref: (_value, _refs) => {
          _refs['payContentRef'] = _value
          payContentRef.value = _value
        },
        onSuccess: paySuccess,
        onError: errorPay
      }, null, 8, ["visible"]),
      _createVNode(SetShop, {
        visible: setShopVisible.value,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((setShopVisible).value = $event)),
        onSubmit: reload,
        vipInfo: vipInfo.value
      }, null, 8, ["visible", "vipInfo"]),
      _createVNode(ADialog, {
        visible: aDialogVisible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((aDialogVisible).value = $event)),
        onSubmit: closeAutoPay,
        isAuto: isAuto.value,
        onReload: getAutoStatus
      }, null, 8, ["visible", "isAuto"]),
      _createVNode(PaySuccessVue, {
        visible: paySuccessVisible.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((paySuccessVisible).value = $event)),
        ref: (_value, _refs) => {
          _refs['paySuccessVue'] = _value
          paySuccessVue.value = _value
        },
        onClose: closePaySuccess
      }, null, 8, ["visible"]),
      _createVNode(AutoPayDisabled, {
        visible: autoPayDisabledVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((autoPayDisabledVisible).value = $event)),
        beforehandVipInfo: beforehandVipInfo.value
      }, null, 8, ["visible", "beforehandVipInfo"]),
      _createVNode(PayError, {
        visible: payErrorVisible.value,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((payErrorVisible).value = $event))
      }, null, 8, ["visible"]),
      _createVNode(VipHistory, {
        visible: vipHistoryVisible.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((vipHistoryVisible).value = $event))
      }, null, 8, ["visible"]),
      _createVNode(CommonDialog, {
        onCancel: _cache[11] || (_cache[11] = ($event: any) => (openVipVisible.value = false)),
        className: "waring_dialog",
        visible: openVipVisible.value,
        width: 480,
        "append-to-body": ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_121, [
            _hoisted_122,
            _createTextVNode(" " + _toDisplayString(_unref(t)('提醒')), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_123, _toDisplayString(_unref(t)('您无法购买该会员，请前往会员中心购买普通会员')), 1),
          _createElementVNode("div", _hoisted_124, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (openVipVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              color: "#008060",
              onClick: openWarinVip,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('开通会员')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(PaypalTip, {
        visible: paypalTipVisible.value,
        "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((paypalTipVisible).value = $event))
      }, null, 8, ["visible"])
    ])
  ], 2)), [
    [_directive_loading, _unref(loading)]
  ])
}
}

})